import React from 'react';
const HeadingUnderline ={
    "text-decoration" :"underline"
}
export default class SOHelpSection extends React.Component {

    render() {
        return(
        <React.Fragment>
            <section className="main bg-grey-6 large-mw-none" role="region">
                <div className="row text-black">
                    <div className="column tiny-12">
                        <div className="all-services-header">
                            <div className="all-services-content vert-top padding-left-small padding-top-tiny">                                
                                <h2 style={HeadingUnderline}>Existing repair request?</h2>
                                <div className="padding-bottom-tiny">
                                If you are looking to check the status of an existing repair request or are looking to update your request please check your repair status.<br/>
                                    <a className="button cta-text mw-large" target="_blank" href="/ForYourHome/VzRepair/FlowEngine/UFDService.aspx?Keyword=Web_TroubleTicket" role="button" data-track="Check repair status" tabIndex="0">Check repair status</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                </section>
        </React.Fragment>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/modules/ServiceOutageHelpSection.js